<template>
  <div>
    <div class="page-title">New Schema</div>
    <Form v-if="form" v-model="form" :submit="create" btnText="Add Schema" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.data-loader.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Schema",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.DataLoaderSchema.new();
      this.form = data;
    },
    async create() {
      await this.$api.DataLoaderSchema.create(this.form);
      this.$router.push("/content-management");
    },
  },
};
</script>

<style></style>
